import { VitalSignOption } from 'src/app/interfaces/vital-signs/vital-sign-option';

export class VitalSignOptionFactory {

  public static fromObject(vitalSignOption: any): VitalSignOption {
    return new class implements VitalSignOption {
      id: number = vitalSignOption.id;
      vitalSignTypeId: number = vitalSignOption.vital_sign_type_id;
      name: string = vitalSignOption.name;
      sort: number = vitalSignOption.sort;
      isActive: boolean = vitalSignOption.is_active; // sicherstellen, dass boolean geliefert wird
      created: string = vitalSignOption.created;
      modified: string = vitalSignOption.modified;
      isDefault: boolean = vitalSignOption.is_default;
      isOther: boolean = vitalSignOption.is_other;
    };
  }

  public static fromArray(vitalSignOptions: any[]): VitalSignOption[] {
    return vitalSignOptions.map(VitalSignOptionFactory.fromObject);
  }
}
